import { from, map, Observable, of, switchMap } from 'rxjs';
import { Attachment } from '../../core';

export function attachmentToFile(attachment: Attachment): Observable<File | null> {
  const fileName = attachment.fileName;
  const mediaType = attachment.mediaType;
  if (!attachment.originalLink || !fileName || !mediaType) {
    return of(null);
  }

  return from(fetch(attachment.originalLink)).pipe(
    switchMap(res => from(res.blob())),
    map(blob => new File([blob], fileName, { type: mediaType })),
  );
}
